export * from './space-location.component';
